import { ApiHandler } from '../ApiHandler'

export abstract class ChatsApi {
  /**
   * Удалить чат пользователя
   */
  public static async delete(userId: number, chatId: number): Promise<void> {
    return await ApiHandler.delete(
      'chats',
      {
        chat_ids: [chatId],
      },
    )
  }
}
